var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    viewBox: "0 0 18 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32617 2.66309C4.32617 1.61719 3.5 0.799805 2.44531 0.799805C1.4082 0.799805 0.573242 1.63477 0.573242 2.66309C0.573242 3.68262 1.4082 4.52637 2.44531 4.52637C3.47363 4.52637 4.32617 3.68262 4.32617 2.66309ZM10.8652 2.66309C10.8652 1.61719 10.0479 0.799805 9.01074 0.799805C7.98242 0.799805 7.14746 1.63477 7.14746 2.66309C7.14746 3.68262 7.98242 4.52637 9.01074 4.52637C10.0303 4.52637 10.8652 3.68262 10.8652 2.66309ZM17.4482 2.66309C17.4482 1.61719 16.6221 0.799805 15.5762 0.799805C14.5303 0.799805 13.6953 1.63477 13.6953 2.66309C13.6953 3.68262 14.5303 4.52637 15.5762 4.52637C16.5957 4.52637 17.4482 3.68262 17.4482 2.66309Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/more-options.90d295df.svg";
export { ForwardRef as ReactComponent };